<!-- <ng-container *ngIf="HasRequiredPermissions"> -->
<div class="bg-white p-6 my-8 rounded-lg shadow w-full max-w-none">

  <app-list-view [listType]="IListType.Stack" [entityType]="ComponentEntityClass" [contextMenuItems]="contextMenuItems" [showActions]="true"
    [canEdit]="canEdit.bind(this)" (entitySelected)="selectSingleItem($event)" (editAction)="editSelectedItem($event)" [showSearchBar]="false" [showCreateButton]="false"
    (deleteAction)="deleteSelectedItem($event)" [dismissEntity]="dismissEntityState.bind(this)" [pagination]="{
                          enabled: false,
                          pageLengths: [5, 10, 20, 50, 100, 300],
                          defaultPageLength: 5,
                          searchColumns: null,
                          sortableColumns: null
                        }" [paginatorType]="'button'" [showHeader]="false" (createButtonClick)="openCreateModal()">
    <!-- Colonne Image -->
    <app-list-table-column key="logo" title="{{ 'image' | translate }}" type="custom">
      <ng-template #customTemplate let-entity>
        <div class="h-12  rounded flex items-center justify-center overflow-hidden">
          @if (entity.relatedTenant?.imageLogo?.thumbnail_Path) {
          <img [src]="rootUrl + entity.relatedTenant.imageLogo.thumbnail_Path" alt="Logo" class="w-full h-full object-contain">
          } @else {
          <span class="text-gray-400 italic text-xs">No logo</span>
          }
        </div>
      </ng-template>
    </app-list-table-column>
    <!-- Colonne Organization -->
    <app-list-table-column key="organizationName"
      title="{{ 'entities.client.propreties.organizationName' | translate }}" type="text" [sortable]="true"
      align="left"></app-list-table-column>
    <!-- Colonne url -->
    <app-list-table-column key="url" title="{{ 'entities.client.propreties.url' | translate }}" type="text"
      [sortable]="true" align="left"></app-list-table-column>
  </app-list-view>


  <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
    [style.width.px]="currentWidth()"
    [hidden]="!isModalOpen()">

    <!-- Poignee interactive (invisible avant le survol)  -->
    <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
      (mousedown)="startResize($event)">
    </div>
    <div class="bg-white h-full rounded-lg shadow-xl p-1">
      <app-client-detail #clientDetail
        [isModal]="true"
        [dataService]="dataService"
        (closeModal)="closeModal($event)"
        (itemSaved)="onItemUpdated($event)"
        (databaseUpdated)="closeModal(true)"
        [EntityInstance]="selectedItem()">
      </app-client-detail>
    </div>
  </div>

</div>


<!-- </ng-container> -->
